/**
 * 環境識別バナーコンポーネント
 *
 * 環境ごとに色を変えて視覚的に環境を識別可能にする。
 * - dev: 青 (bg-blue-500)
 * - stg: 赤 (bg-red-500)
 * - prod: 非表示
 * - その他: 黄色 (bg-yellow-500)
 */

import { ENV } from "../../config/env";

const ENVIRONMENT_COLORS: Record<string, string> = {
  dev: "bg-blue-500",
  stg: "bg-red-500",
  prod: "", // 本番環境では非表示
};

export function EnvironmentBanner() {
  const env = ENV.VITE_ENV;

  // 本番環境では非表示
  if (env === "prod") {
    return null;
  }

  // 環境に応じたカラークラスを取得（デフォルトは黄色）
  const colorClass = ENVIRONMENT_COLORS[env] || "bg-yellow-500";

  return (
    <div
      className={`fixed top-0 left-0 right-0 h-[3px] ${colorClass} z-[9999]`}
      role="banner"
      aria-label={`Environment: ${env}`}
    />
  );
}
